// IMPORTANT: THIS FILE IS AUTO GENERATED! DO NOT MANUALLY EDIT OR CHECKIN!
/* tslint:disable */
export const VERSION = {
    "dirty": false,
    "raw": "v19.0.17-0-g4eacc2a",
    "hash": "g4eacc2a",
    "distance": 0,
    "tag": "v19.0.17",
    "semver": {
        "options": {
            "loose": false,
            "includePrerelease": false
        },
        "loose": false,
        "raw": "v19.0.17",
        "major": 19,
        "minor": 0,
        "patch": 17,
        "prerelease": [],
        "build": [],
        "version": "19.0.17"
    },
    "suffix": "0-g4eacc2a",
    "semverString": "19.0.17",
    "version": "19.0.17",
    "date": "2025-10-14T14:40:12.661Z"
};
/* tslint:enable */
